"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=e=>e===void 0?!1:!e;exports.getOpenAvailyBookingFromAppointment=o;
